// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"a2389a19","119":"88cab638","377":"c561d216","536":"cc726c38","552":"e903b273","621":"1e05d7ee","644":"17e1f8d2","667":"133cc425","753":"d8341b8c","765":"36d4bdd1","766":"ff924c55","787":"0164a660","868":"d94b70ac","916":"01d8ccbf","967":"7245ef5d","993":"739b228b"}[chunkId] + ".chunk.js";
};